import { useQuery } from "@tanstack/react-query";
import { useApi } from "~/hooks/use-api";
import { useProduct } from "~/contexts/product-context";

export const useAcpFeedPreview = () => {
  const api = useApi();
  const { product } = useProduct();
  const productId = product?.id;

  return useQuery({
    queryKey: ["product-acp-feed-preview", productId],
    queryFn: () => api.products.getProductAcpFeedPreview(productId!),
    enabled: !!productId,
  });
};
